<template>
  <b-modal ref="modal" hide-footer centered title="Create New Table">
    <b-form @submit.prevent="save">
      <b-form-group label="Table title:" v-if="!selectExisting">
        <b-form-input
          type="text"
          v-model.trim="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProcess"
          autocomplete="off"
          ref="titleInput"
        />
        <b-form-invalid-feedback v-if="!$v.title.required">Table title is required</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.isUnique"
        >There's a Table with the same title already exists</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.alphaNum"
        >Table title accepts only alphanumerics and can not start with number or dash sign</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Table:" v-else>
        <b-form-select
          v-model="$v.selectedDataGrid.$model"
          :class="{ 'is-invalid': $v.selectedDataGrid.$error }"
          :options="dataGrids"
          :disabled="inProcess"
        />
        <b-form-invalid-feedback v-if="!$v.selectedDataGrid.required">Table is required</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group v-if="dataGrids.length">
        <b-form-checkbox v-model="selectExisting">
          <span style="vertical-align: 0px;">Select existing Table</span>
        </b-form-checkbox>
      </b-form-group>
      <b-button variant="success" type="submit" :disabled="inProcess">
        <b-spinner v-if="inProcess" small style="vertical-align: -2px;"></b-spinner>
        <span v-if="!inProcess">Create</span>
        <span v-else>Creating...</span>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// validations
import {
  required,
  helpers,
  requiredIf,
  requiredUnless,
} from 'vuelidate/lib/validators'
const alphaNum = helpers.regex('alphaNum', /^[A-Za-z][A-Za-z0-9_-\s]*$/)
// helpers
import eventBus from '@/helpers/event-bus'
import utils from '@/helpers/utils/index.js'
// services
import db from '@/services/db'

export default {
  data() {
    return {
      inProcess: false,
      title: '',
      selectExisting: false,
      selectedDataGrid: null,
    }
  },
  validations: {
    title: {
      required: requiredUnless('selectExisting'),
      isUnique(value) {
        if (!this.title) return true
        if (this.selectExisting) return true
        if (!this.dataGrid_options) return true

        const grids = Object.keys(this.dataGrid_options)

        if (!grids.includes(utils.sanitize(this.title))) return true

        return false
      },
      alphaNum,
    },
    selectedDataGrid: {
      required: requiredIf('selectExisting'),
    },
  },
  computed: {
    ...mapState(['currentTab', 'currentSubTab', 'dataGrid_options']),
    dataGrids() {
      const dataGrids = []

      if (!this.dataGrid_options) return dataGrids

      for (let gridId in this.dataGrid_options) {
        if (!this.dataGrid_options[gridId]) {
          continue
        }
        dataGrids.push({
          text: this.dataGrid_options[gridId].title,
          value: gridId,
        })
      }

      return dataGrids
    },
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()

      setTimeout(() => {
        this.$refs.titleInput.focus()
      })
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      if (this.inProcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProcess = true

      this.$v.$reset()

      if (this.selectExisting) {
        const data = {
          gridId: this.selectedDataGrid,
          tab: this.currentTab,
          subtab: this.currentSubTab,
        }

        await db.dataGrid.widget.copy(data)
      } else {
        const data = {
          title: this.title,
          source: this.$sanitize(this.title),
          storageType: 'dashboard',
          tab: this.currentTab,
          subtab: this.currentSubTab,
          gsOptions: {
            w: 24,
            h: 18,
          },
        }

        await db.dataGrid.widget.createNew(data, null, true)

        eventBus.$emit('dataGridAdded', data.source)
      }

      this.title = ''
      this.inProcess = false
      this.selectExisting = false
      this.selectedDataGrid = null

      this.close()
    },
  },
  created() {
    eventBus.$on('addTable', this.open)
  },
  beforeDestroy() {
    eventBus.$off('addTable', this.open)
  },
}
</script>
